import { Component, OnInit, EventEmitter, Output, ViewEncapsulation, Input } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ParametroGrafico } from '../../comum/modelos/parametro-grafico';

@Component({
  selector: 'app-modal-parametros-grafico',
  templateUrl: './modal-parametros-grafico.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-parametros-grafico.component.css']
})
export class ModalParametrosGraficoComponent implements OnInit {
  @Input() origem: string;
  @Input() parametroGraficoInput: ParametroGrafico;
  @Output() parametrosGraficoEvent: EventEmitter<ParametroGrafico>;
  public parametroGrafico: ParametroGrafico;

  constructor(private modalService: NgbModal) {
    this.parametrosGraficoEvent = new EventEmitter<ParametroGrafico>();
  }

  cadastrar(content) {
    const ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      windowClass: 'modalParametrosGrafico',
      size: 'lg'
    };
    this.modalService.open(content, ngbModalOptions).result.then((result) => {
      this.parametroGrafico = result;
      this.parametrosGraficoEvent.emit(this.parametroGrafico);
    }, (reason) => {
    });
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/dashboards/modal-parametros-grafico/modal-parametros-grafico.component.ts